import { apiSlice } from "@/redux/apiSlice";

export const defineApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
      getProjectDetails: builder.query({
        query: (projectId) => `/projects/getProjectDetails/${projectId}`,
      }),
      getProjects: builder.query<any, { scope?: 'mine' | 'all' } | void>({
        query: (params) => {
          const scope = params?.scope;
          return scope ? `/projects/getProjects?scope=${encodeURIComponent(scope)}` : `/projects/getProjects`;
        },
        providesTags: ['getProjects'],
      }),
      getUsers: builder.query<any, void>({
        query: () => '/projects/getUsers',
        providesTags: ['User'],
      }),
      createProject: builder.mutation<any, any>({
        query: (body) => ({
          url: '/projects/createProject',
          method: 'POST',
          body,

        }),
        invalidatesTags: ['getProjects'],
      }),
      updateProjectTarget: builder.mutation<any, any>({
        query: (body) => ({
          url: '/projects/updateProjectTarget',
          method: 'POST',
          body,
        }),
      }),
      updatePalletFtlFields: builder.mutation<any, any>({
        query: (body) => ({
          url: '/projects/updatePalletFtlFields',
          method: 'POST',
          body,
        }),
      }),
      addUsersToProject: builder.mutation<any, { projectId: number; userIds: number[] }>({
        query: (data) => ({
          url: '/projects/addUsersToProject',
          method: 'POST',
          body: data,
        }),
        // invalidatesTags: ['Project'],
      }),
      validatePalletConfig: builder.query<any, any>({
        query: (projectId) => `/projects/validatePalletConfig/${projectId}`,
        providesTags: ['PalletConfig'],
      
      }),
      deleteShippigMode: builder.mutation<any, any>({
        query: ({shippingModeId}) => ({
          url: `/projects/shipping-modes/${shippingModeId}`,
          method: 'DELETE',

        }),
      }),
      deleteProject: builder.mutation<any, number | string>({
        query: (projectId) => ({
          url: `/projects/deleteProject/${projectId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['getProjects'],
      }),
  }),
  overrideExisting:true
});



export const {
  useGetProjectDetailsQuery,
  useCreateProjectMutation,
  useUpdateProjectTargetMutation,
  useGetProjectsQuery,
  useUpdatePalletFtlFieldsMutation,
  useAddUsersToProjectMutation,
  useGetUsersQuery,
  useDeleteShippigModeMutation,
  useDeleteProjectMutation,
  useValidatePalletConfigQuery  
} = defineApiSlice;
